"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = executeRulesSuccess;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _assign = _interopRequireDefault(require("lodash/assign"));
var _transform = _interopRequireDefault(require("lodash/transform"));
var _forEach = _interopRequireDefault(require("lodash/forEach"));
var _choiceFunctions = _interopRequireDefault(require("./choiceFunctions"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function executeRulesSuccess(state, _ref) {
  var disabledChoices = _ref.disabledChoices,
    selectedChoices = _ref.selectedChoices,
    options = _ref.options,
    data = _ref.data;
  var newState = (0, _transform["default"])(state, function (ns, choice, choiceId) {
    return (
      // eslint-disable-next-line no-param-reassign
      ns[choiceId] = _objectSpread(_objectSpread({}, choice), {}, {
        isActive: !disabledChoices[choice.id]
      })
    );
  }, {});
  (0, _forEach["default"])(data.changedOptions, function (_ref2) {
    var after = _ref2.after,
      before = _ref2.before,
      optionId = _ref2.optionId,
      property = _ref2.property;
    if (property === 'ChoiceValue') {
      var option = options[optionId];
      if (option) {
        var choiceId = option.choices[0];
        var choice = newState[choiceId];
        if (choice) {
          choice.value = after;
          choice.isSelected = true;
        }
      }
    }
    if (property === 'ChoiceId') {
      var beforeChoice = newState[before];
      if (beforeChoice) {
        beforeChoice.isSelected = false;
      }
      var afterChoice = newState[after];
      if (afterChoice) {
        afterChoice.isSelected = true;
      }
    }
  });
  (0, _forEach["default"])(selectedChoices, function (_ref3) {
    var optionId = _ref3.optionId,
      choiceId = _ref3.choiceId;
    var value = (0, _choiceFunctions["default"])(state[choiceId], null);
    if (newState[choiceId]) {
      (0, _assign["default"])(newState[choiceId], {
        value: value,
        isSelected: true
      });
    }
    if (options[optionId]) {
      options[optionId].choices.filter(function (it) {
        return it !== choiceId;
      }).forEach(function (it) {
        newState[it].isSelected = false;
      });
    }
  });
  return newState;
}
//# sourceMappingURL=executeRulesSuccess.js.map